import React from 'react'

import {noop} from 'es-toolkit'

import './mixed-value-form-section.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import Button from '../../../../commons/src/components/button'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    unlockButtonLabel: string
    locked?: boolean
    onClick: React.MouseEventHandler
  }
>

const MixedValueFormSection = ({
  className,
  children,
  unlockButtonLabel,
  locked = false,
  onClick = noop,
  ...props
}: Props) => (
  <div {...props} className={cn('MixedValueFormSection', {locked}, className)}>
    <div className="MixedValueFormSection__form">{children}</div>
    <div className="MixedValueFormSection__button">
      <Button hierarchy="secondary" onClick={onClick}>
        {unlockButtonLabel}
      </Button>
    </div>
  </div>
)

export default MixedValueFormSection
